import { createAnalytics } from '@/shared/features/analytics/config/analytics.build';
import {
  commonFacebookEventsUtil,
  getConnectoId,
} from '@/shared/features/analytics/utils/facebookCommonAttributes';

/**
 * Fires route-level PageView to Meta (pixel + CAPI) and WebEngage.
 * Common client attributes (Page Name, UTM params, etc.) are merged by the WebEngage adapter.
 */
export function trackPageView(): void {
  const connectoId = getConnectoId();
  commonFacebookEventsUtil(
    'PageView',
    connectoId ? { CONNECTO_ID: connectoId } : {},
  );

  createAnalytics()
    .then((analytics) => {
      analytics.trackEvent('PageView', {}, { eventProviders: ['webengage'] });
    })
    .catch(() => {
      // Analytics may be unavailable if SDK init failed
    });
}
